import { render, staticRenderFns } from "./NewsPreview.vue?vue&type=template&id=773e02bc"
import script from "./NewsPreview.vue?vue&type=script&lang=js"
export * from "./NewsPreview.vue?vue&type=script&lang=js"
import style0 from "./NewsPreview.vue?vue&type=style&index=0&id=773e02bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports